/**
 * Párrafo item
 * @param {*} editor
 */
function latex(editor) {
  const cm = editor.codemirror;
  const selectedText = cm.getSelection();
  const text = selectedText;

  const output = `$$${text}$$`;
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'Latex',
    action: latex,
    className: 'latexicon',
    title: 'Latex',
  };

  return option;
}
